export default __webpack_public_path__ + "static/media/arena-bg.fc646fca.png";